import { templateResult } from './templates'
import { readPageProject } from '@/schema/page-project'
import { isCanvasProjectType } from './project-types'

// 新增只提交可编辑字段，主键及 target 交由平台服务生成。
export function screenCreatePayload (form, type = 'big_screen') {
  if (!isCanvasProjectType(type)) throw new Error('项目类型无效')
  if (!form || typeof form.name !== 'string' || !form.name.trim() || form.name.trim().length > 128 || typeof form.catalogId !== 'string' || !form.catalogId.trim() || String(form.description || '').length > 1000) throw new Error('请填写有效的大屏名称和分类，名称最多128字，说明最多1000字')
  return { name: form.name.trim(), catalogId: form.catalogId.trim(), description: String(form.description || '').trim(), type, target: '', state: { text: '启用', value: 'enabled' } }
}

export function confirmScreenCreated (response, type = 'big_screen') {
  const record = templateResult(response)
  if (!isCanvasProjectType(type) || !record || typeof record.id !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(record.id) || record.type !== type) throw new Error('新增结果未确认，请到项目列表检查，勿重复创建')
  return record
}

export function confirmScreenImported (response, submitted) {
  const record = confirmScreenCreated(response, submitted.type || 'big_screen')
  const fail = () => { throw new Error('导入结果未确认，请到大屏列表检查，勿重复提交') }
  if (record.name !== submitted.name || record.catalogId !== submitted.catalogId || record.description !== submitted.description ||
      typeof record.target !== 'string' || !record.target.trim() || record.target.length > 32 ||
      record.publicationStatus !== 'unpublished' || record.coverFileId ||
      !(record.state === 'enabled' || (record.state && record.state.value === 'enabled'))) fail()
  const model = readPageProject(record), metadata = model.metadata
  if (!metadata.config || metadata.config.id !== record.id || metadata.config.visualId !== record.id || model.visual.id !== record.id ||
      Object.prototype.hasOwnProperty.call(model.visual, 'password') ||
      Object.prototype.hasOwnProperty.call(metadata, 'previewControlVersionId') ||
      Object.prototype.hasOwnProperty.call(metadata, 'templatePreview')) fail()
  return record
}
